import React, { useState } from "react";
import PropTypes from "prop-types";
import UserDialog from "../Form/UserDialog";
import { createUserService } from "modules/usuario/services/userService";

export default function HeaderUser({ onUserCreated, children }) {
  const [open, setOpen] = useState(false);
  const handleCreate = async (data) => {
    const created = await createUserService(data);
    onUserCreated?.(created);
    setOpen(false);
  };
  return (
    <>
      {children(() => setOpen(true))}
      <UserDialog open={open} onClose={() => setOpen(false)} onSubmit={handleCreate} />
    </>
  );
}
HeaderUser.propTypes = { onUserCreated: PropTypes.func, children: PropTypes.func.isRequired };
